import React from 'react';
import { useTranslation } from 'react-i18next';

interface IIntegrationCard {
  link: string,
  Icon: React.FC<{fill: string}>,
  title: string,
  description: string,
  buttonText?: string,
  separator?: string
}

const IntegrationCard: React.FC<IIntegrationCard> = ({ 
  link, 
  Icon,
  title,
  description,
  buttonText = "add",
  separator = "+"
}) => {
  
  const { t } = useTranslation();

  return (
    <a
      className="
      cursor-pointer bg-white shadow-lg rounded-sm shadow-sm transition-all
      "
      target="_blank"
      href={link}>
      <div className="flex flex-col p-5 border border-gray-200 hover:border-gray-300 h-full">
        <div className="flex-grow">
          <header className="flex items-center mb-4">
            <div 
              className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 mr-3`}
            >
              <Icon fill="#1F55A1" />
            </div>
            <h3 className="text-base text-gray-800 text-left font-semibold">
              {t(title, { ns: 'messages' })}
            </h3>
          </header>
          <div className="text-sm text-left w-10/12 text-black">
            {t(description)}.
          </div>
        </div>
        <footer className="mt-4">
          <div className="flex flex-wrap  justify-between items-center">
            <button className="btn-sm border-gray-200 hover:border-gray-300 shadow-sm flex items-center">
              <span className="text-[#1f55a1]">
                {t(buttonText, { ns: 'messages' })}
              </span>
            </button>
          </div>
        </footer>
      </div>
    </a>
  );
}

export default IntegrationCard;
